import { provinces } from "../assets/data";

export const splitFullName = (fullName) =>{
    const nameParts = fullName.trim().split(/\s+/); // Split by one or more spaces
  
    let firstName = "";
    let lastName = "";
  
    if (nameParts.length > 1) {
      firstName = nameParts.slice(0, -1).join(" ");
      lastName = nameParts[nameParts.length - 1];
    } else if (nameParts.length === 1) {
      firstName = nameParts[0];
    }
  
    return { firstName, lastName };
}

export const toggleElementInArray=(array, element) =>{
  const index = array.indexOf(element); // Check if the element exists in the array
  if (index === -1) {
    // If it doesn't exist, add it
    array.push(element);
  } else {
    // If it exists, remove it
    array.splice(index, 1);
  }
  return array; // Return the updated array (optional)
}

// Province code/name mapping helpers

/**
 * Get province code from province name
 * @param {string} provinceName - The province/state name
 * @param {string} country - The country name (Canada or USA)
 * @returns {string|null} - The province code or null if not found
 */
export const getProvinceCodeFromName = (provinceName, country = null) => {
  if (!provinceName) return null;
  
  // If it's already a code (2 letters), return it
  if (provinceName.length === 2 && /^[A-Z]{2}$/.test(provinceName)) {
    return provinceName;
  }
  
  // Search in both countries if country not specified
  const countriesToSearch = country 
    ? [country] 
    : ['Canada', 'USA'];
  
  for (const countryName of countriesToSearch) {
    if (provinces[countryName]) {
      const province = provinces[countryName].find(
        p => p.label.toLowerCase() === provinceName.toLowerCase()
      );
      if (province) {
        return province.value;
      }
    }
  }
  
  return null;
};

/**
 * Get province name from province code
 * @param {string} provinceCode - The province/state code (e.g., "ON", "AB")
 * @param {string} country - The country name (Canada or USA)
 * @returns {string|null} - The province name or null if not found
 */
export const getProvinceNameFromCode = (provinceCode, country = null) => {
  if (!provinceCode) return null;
  
  // If it's already a name (more than 2 characters), return it
  if (provinceCode.length > 2) {
    return provinceCode;
  }
  
  // Search in both countries if country not specified
  const countriesToSearch = country 
    ? [country] 
    : ['Canada', 'USA'];
  
  for (const countryName of countriesToSearch) {
    if (provinces[countryName]) {
      const province = provinces[countryName].find(
        p => p.value.toUpperCase() === provinceCode.toUpperCase()
      );
      if (province) {
        return province.label;
      }
    }
  }
  
  return null;
};

// Country code/name mapping helpers
// Standard ISO country codes: Canada = "CA", USA = "US"

/**
 * Get country code from country name
 * @param {string} countryName - The country name (e.g., "Canada", "USA")
 * @returns {string|null} - The country code (e.g., "CA", "US") or null if not found
 */
export const getCountryCodeFromName = (countryName) => {
  if (!countryName) return null;
  
  // If it's already a code (2 letters), return it
  if (countryName.length === 2 && /^[A-Z]{2}$/.test(countryName)) {
    return countryName.toUpperCase();
  }
  
  // Map common country names to codes
  const countryMap = {
    'canada': 'CA',
    'usa': 'US',
    'united states': 'US',
    'united states of america': 'US'
  };
  
  const normalizedName = countryName.toLowerCase().trim();
  return countryMap[normalizedName] || null;
};

/**
 * Get country name from country code
 * @param {string} countryCode - The country code (e.g., "CA", "US")
 * @returns {string|null} - The country name (e.g., "Canada", "USA") or null if not found
 */
export const getCountryNameFromCode = (countryCode) => {
  if (!countryCode) return null;
  
  // If it's already a name (more than 2 characters), return it
  if (countryCode.length > 2) {
    return countryCode;
  }
  
  // Map country codes to names
  const codeMap = {
    'CA': 'Canada',
    'US': 'USA'
  };
  
  return codeMap[countryCode.toUpperCase()] || null;
};
  
  